@if (topApplicationBarVisible) {
<gx-navbar
  [backButtonLabel]="'Back' | translate"
  caption="{{ appBarNavigation.caption }}"
  [cssClass]="appBarNavigation.class"
  [enableHeaderRowPattern]="appBarNavigation.enableHeaderRowPattern"
  [headerRowPatternCssClass]="appBarNavigation.headerRowPatternCssClass"
  [layoutSize]="currentLayoutSize"
  [leftTargetVisible]="layoutState.leftVisible"
  [rightTargetVisible]="layoutState.rightVisible"
  [showBackButton]="appBarNavigation.showBackButton"
  [showHeaderRowPatternClass]="app.showHeaderRowPatternClass"
  [showToggleButton]="
    appBarNavigation.navigationStyle === 'slide' && layoutState.leftComponent !== null
  "
  toggleButtonLabel="{{ appBarNavigation.toggleButtonLabel }}"
  gx-form-properties
  (backButtonClick)="handleBackButtonClick()"
  (toggleButtonClick)="handleToggleButtonClick()">
  @for (item of appBarNavigation.navigationItems; track item.id) {
  <gx-navbar-item
    slot="navigation"
    cssClass="{{ item.class }}"
    iconSrcset="{{ item?.icon | imageToSrcset:this.app.uiContextKey }}"
    [layoutSize]="currentLayoutSize"
    [@appBarItemEnterLeaveAnimation]
    (click)="item.onClick()"
  >
    {{ item.caption }}
  </gx-navbar-item>
  }
  @for (item of appBarNavigation.actionItems; track item.id) {
  <gx-navbar-item
    slot="{{ item?.slotName }}"
    cssClass="{{ item?.class }}"
    [hidden]="item?.visible | not"
    [disabled]="item?.enabled | not"
    iconSrcset="{{ item?.icon | imageToSrcset:this.app.uiContextKey }}"
    [layoutSize]="currentLayoutSize"
    (click)="item.onClick()"
  >
    {{ item?.caption }}
  </gx-navbar-item>
  }
</gx-navbar>
}

<gx-ng-multi-outlet
  [layoutSize]="currentLayoutSize"
  [enableHeaderRowPattern]="appBarNavigation.enableHeaderRowPattern"
  [topNavbarVisible]="topApplicationBarVisible"
  [bottomNavbarVisible]="bottomApplicationBarVisible"
  [isLoading]="isLoading"
  (layoutChange)="handleLayoutChange($event)"
>
  @if(!isLoading) {
  <router-outlet></router-outlet>
  }
</gx-ng-multi-outlet>

@if(bottomApplicationBarVisible) {
<gx-navbar
  [cssClass]="appBarNavigation.class"
  position="bottom"
  gx-form-properties
>
  @for (item of appBarNavigation.navigationItems; track trackAppBarItemById) {
  <gx-navbar-item
    slot="navigation"
    cssClass="{{ item.class }}"
    iconSrcset="{{ item?.icon | imageToSrcset:this.app.uiContextKey }}"
    [layoutSize]="currentLayoutSize"
    [@appBarItemEnterLeaveAnimation]
    (click)="item.onClick()"
  >
    {{ item.caption }}
  </gx-navbar-item>
  }
</gx-navbar>
}
